import {useTranslation} from '@/translations/i18n.tsx'
import {ModalCloseButton, ModalHeader, ModalHeaderTitle} from '@components/ui/modal-atoms'
import {Dialog, DialogClose, DialogContent} from '@components/ui/dialog'
import {FC, useState} from 'react'
import {OtpSmsEditStep} from '@/features/settings/components/change-phone-modal-otp-sms-edit-step'
import {OtpSmsPendingConfirmationStep} from '@/features/settings/components/change-phone-modal-otp-sms-pending-confirmation-step'

interface ChangeChangePhoneModalProps {
    onClose: () => void
    phoneNumber: string | null
}

export const ChangePhoneModal: FC<ChangeChangePhoneModalProps> = ({onClose, phoneNumber}) => {
    const {t} = useTranslation()
    const [phoneNumberValue, setPhoneNumberValue] = useState(phoneNumber ?? '')
    const [otpSmsActiveStep, setOtpStep] = useState<'edit' | 'pending_confirmation'>('edit')

    return (
        <Dialog open={true} onOpenChange={onClose}>
            <DialogContent className="w-120 overflow-visible" showCloseButton={false}>
                <ModalHeader className="grid grid-cols-[32px_1fr_32px] items-center justify-center border-none">
                    <DialogClose data-slot="dialog-close" render={<ModalCloseButton />} />
                    <ModalHeaderTitle className="p-0">
                        {t(
                            phoneNumber
                                ? 'settings:personal_information:change_number'
                                : 'settings:personal_information:add_number'
                        )}
                    </ModalHeaderTitle>
                </ModalHeader>

                {otpSmsActiveStep == 'edit' && (
                    <OtpSmsEditStep
                        onClose={onClose}
                        setPhoneNumberValue={setPhoneNumberValue}
                        phoneNumber={phoneNumber}
                        setOtpStep={setOtpStep}
                    />
                )}

                {otpSmsActiveStep == 'pending_confirmation' && (
                    <OtpSmsPendingConfirmationStep phoneNumberValue={phoneNumberValue} onClose={onClose} />
                )}
            </DialogContent>
        </Dialog>
    )
}
